import { useEffect, useState } from "react";

const KEY = "vsf_prices_hidden";
const EVT = "vsf-prices-visibility";

export function usePricesHidden() {
    const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
    useEffect(() => {
        const sync = () => setHidden(localStorage.getItem(KEY) === "1");
        window.addEventListener(EVT, sync);
        return () => window.removeEventListener(EVT, sync);
    }, []);
    const toggle = () => {
        localStorage.setItem(KEY, localStorage.getItem(KEY) === "1" ? "0" : "1");
        window.dispatchEvent(new Event(EVT));
    };
    return [hidden, toggle];
}

export const maskPrice = (hidden, formatted) => (hidden ? "€ ••••" : formatted);
